import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'

export const isSameDay = (value, now) =>
  value.getDate() === now.getDate() && value.getMonth() === now.getMonth() && value.getFullYear() === now.getFullYear()

const isDayBefore = (value, now) => {
  // Copy "now"
  const dayBeforeNow = new Date(now)
  dayBeforeNow.setUTCDate(now.getUTCDate() - 1)
  return (
    value.getDate() === dayBeforeNow.getDate() &&
    value.getMonth() === dayBeforeNow.getMonth() &&
    value.getFullYear() === dayBeforeNow.getFullYear()
  )
}

export default function date(value, { now = new Date() } = {}) {
  const i18n = useI18nForVue2()
  if (!value) {
    return ''
  }
  const dateValue = new Date(value)
  if (isSameDay(dateValue, now)) {
    return i18n.t('dates.today')
  }
  if (isDayBefore(dateValue, now)) {
    return i18n.t('dates.yesterday')
  }
  return dateValue.toLocaleDateString(i18n.locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}
